export const experiences = [
  {
    id: 1,
    role: "Web Developer",
    company: "Azaya Marketing LLC",
    location: "Dubai, UAE",
    // ✏️ Easy to edit — update these dates as needed
    startDate: "Oct 2025",
    endDate: "Present",
    achievements: [
      "Developed scalable web applications and WordPress platforms with performance-focused architecture",
      "Conducted website audits and improved performance, SEO, and Core Web Vitals",
      "Improved website performance and reduced load time by 30–40%",
      "Built advanced custom plugins including real-time systems like currency calculators and trading dashboards using APIs",
      "Designed and implemented a Broker Review Platform with authentication, user profiles, and moderation workflows",
      "Integrated third-party APIs for real-time data processing and business logic automation",
      "Migrated WordPress platforms to Next.js for improved frontend performance and SEO",
      "Developed Node.js APIs for forms, blogs, and dynamic data processing",
      "Built scalable systems integrating APIs, AI workflows, and modern frontend technologies",
    ],
  },
  {
    id: 2,
    role: "Senior WordPress Developer",
    company: "DIKONIA",
    location: "India",
    startDate: "Apr 2022",
    endDate: "Apr 2025",
    achievements: [
      "Led development of scalable WordPress applications, custom themes, and plugins",
      "Built multilingual SEO-optimized platforms",
      "Integrated AI APIs (LLMs) for content automation and improved user experience",
      "Implemented secure payment gateway systems",
      "Delivered client projects with optimized performance and scalable architecture",
      "Developed backend modules using Laravel and MySQL",
      "Integrated Google APIs including Maps, location, and distance calculations",
      "Built admin dashboards and business systems including food ordering with delivery tracking",
      "Upgraded CakePHP and CodeIgniter legacy systems",
    ],
  },
  {
    id: 3,
    role: "Web Developer",
    company: "FORTECH WEB SOLUTIONS",
    location: "India",
    startDate: "Feb 2020",
    endDate: "Mar 2022",
    achievements: [
      "Developed and optimized CMS platforms using Core PHP and MySQL",
      "Built Laravel-based systems integrated with WordPress",
      "Delivered responsive WordPress websites using Elementor, Divi, WPBakery, and Oxygen",
      "Implemented custom plugins and SEO-focused features",
      "Developed payment gateway integrations",
    ],
  },
];
